module.exports = __webpack_public_path__ + "img/icon-cms.b86041e3.svg";